#import "../NoteFields.graphql"
#import "../EditHistoryFields.graphql"

fragment UsDueDiligenceBooleanFieldDetails on UsDueDiligenceBooleanField {
  value
  suggestedStatus
  reason
}

fragment UsDueDiligenceStringFieldDetails on UsDueDiligenceStringField {
  value
  suggestedStatus
  reason
}

fragment UsDueDiligenceDateFieldDetails on UsDueDiligenceDateField {
  value
  suggestedStatus
  reason
}

fragment UsDueDiligenceAttachmentFields on UsDueDiligenceAttachment {
  id
  fileName
  downloadUrl
  createdAt
}

fragment UsDueDiligenceFields on UsDueDiligence {
  id
  organizationName
  ein
  charity {
    id
    name
    usDueDiligences {
      id
    }
  }
  subsectionCode {
    ...UsDueDiligenceStringFieldDetails
  }
  foundationCode {
    ...UsDueDiligenceStringFieldDetails
  }
  yearOfIncorporation
  location
  isFlaggedInOfac {
    ...UsDueDiligenceBooleanFieldDetails
  }
  isIrsPub78Compliant {
    ...UsDueDiligenceBooleanFieldDetails
  }
  isCaliforniaAttorneyGeneralRegistryCompliant {
    ...UsDueDiligenceBooleanFieldDetails
  }
  isCaliforniaFranchiseTaxBoardCompliant {
    ...UsDueDiligenceBooleanFieldDetails
  }
  rulingDate {
    ...UsDueDiligenceDateFieldDetails
  }
  suggestedStatus {
    status
    reasons
  }
  zeroHarmReview {
    id
    taskId
    aiReviewStatus
    status
    flagDetails {
      label
      flagged
    }
    granteeIdentificationConfidence
    report
    notes
    createdAt
    updatedAt
  }
  status
  isExpired
  createdAt
  updatedAt
  boardMembers
  attachments {
    ...UsDueDiligenceAttachmentFields
  }
  notes {
    ...NoteFields
  }
  editHistory {
    ...EditHistoryFields
  }
}
